export default __webpack_public_path__ + "static/media/circle.ee8bb2e5.svg";